import React from "react";
import CashBalanceRecharge from "../../components/walletReports/cashBalanceRecharge";

const CashBalanceRechargePage = () => {
  return <CashBalanceRecharge />;
};

export default CashBalanceRechargePage;
